// extracted by mini-css-extract-plugin
export var readonly = "_ck-1";
export var star = "_ck-0";